import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import IconPlay from 'components/icons/iconPlay2';
import IconPause from 'components/icons/iconPause';

const VideoPlayButton = ({
  color = 'transparent',
  styling = 'outline-button',
  isPlaying = true,
  onClick,
  disabled = false,
  size = 'base',
  children,
}) => (
  <button
    onClick={onClick}
    disabled={disabled}
    className={classNames(
      `font-sans flex flex-row no-underline justify-evenly font-bold`,
      {
        'VideoPlayButton--styling-solid-button': styling === 'solid-button',
        'min-w-[140px] px-[0.8rem] py-8 inline-flex h-[50px] flex-row items-center justify-between border-2 bg-transparent':
          styling === 'outline-button',
        'border-transparent':
          styling === 'outline-button' && color === 'transparent',
        'border-gray text-gray hover:border-brand hover:text-brand':
          styling === 'outline-button' && color === 'black',
        'border-brand text-brand hover:border-brand hover:text-brand':
          styling === 'outline-button' && color === 'brand',
        'text-xs': size === 'xs',
        'text-sm': size === 'sm',
        'text-base': size === 'base',
        'text-lg': size === 'lg',
        'text-xl': size === 'xl',
        'text-2xl': size === '2xl',
        'text-3xl': size === '3xl',
        'text-4xl': size === '4xl',
      }
    )}
    type="button"
  >
    <span className="text-lg">{children}</span>
    <span className="VideoPlayButton__icon">
      {!isPlaying ? (
        <IconPlay width="15px" height="15px" />
      ) : (
        <IconPause width="15px" height="15px" />
      )}
    </span>
  </button>
);

VideoPlayButton.propTypes = {
  children: PropTypes.node.isRequired,
  onClick: PropTypes.func.isRequired,
  styling: PropTypes.oneOf(['solid-button', 'outline-button']),
  size: PropTypes.oneOf(['xs', 'sm', 'base', 'lg', 'xl', '2xl', '3xl', '4xl']),
  color: PropTypes.oneOf(['brand', 'black', 'white', 'transparent']),
  disabled: PropTypes.bool,
  isPlaying: PropTypes.bool,
};

export default VideoPlayButton;
